import { modelOptions, post, prop } from "@typegoose/typegoose";
import { z } from "zod";
import { ENTITY_NAME_MAX_LENGTH, entityNameZodValidator } from "../../validators/index.js";
import { getZodSchemaFromClass, validate } from "../../zod-decorator/index.js";
import { addSchemaKeyHook, getDefaultSchemaOptions, SchemaBase, SchemaConstructorArgs } from "../schemaBase.js";
import type { ExternalLinkFieldsWithDefaults, ExternalLinkSchemaTypes } from "../types/externalLink.d.js";
import { type DtoValidatorTypes } from "../validatableClass.js";

const SCHEMA_KEY = "ExternalLink" as const;

@modelOptions({ schemaOptions: { ...getDefaultSchemaOptions(SCHEMA_KEY) } })
@post<SchemaBase<ExternalLink>>(...addSchemaKeyHook(SCHEMA_KEY))
export class ExternalLink extends SchemaBase<ExternalLink, ExternalLinkFieldsWithDefaults> {
    static readonly schemaKey = SCHEMA_KEY;

    @validate({ schemaKey: SCHEMA_KEY })
    readonly schemaKey = SCHEMA_KEY;

    @validate({ zodValidator: z.string() })
    @prop({ type: () => String, required: true })
    public key!: string;

    @validate({ zodValidator: entityNameZodValidator })
    @prop({ type: () => String, required: true, maxlength: ENTITY_NAME_MAX_LENGTH })
    public name!: string;

    @validate({ zodValidator: z.string() })
    @prop({ type: () => String, required: true })
    public url!: string;

    static getters = {} as const satisfies Record<string, (self: ExternalLink) => any>;

    static utilities = {} as const satisfies Record<string, (...args: any) => any>;

    static dtoValidators: DtoValidatorTypes<ExternalLinkSchemaTypes>;

    constructor(properties?: SchemaConstructorArgs<ExternalLink, ExternalLinkFieldsWithDefaults>) {
        super(properties);
        Object.assign(this, properties);
    }
}

ExternalLink.dtoValidators = getZodSchemaFromClass(
    ExternalLink,
) as unknown as DtoValidatorTypes<ExternalLinkSchemaTypes>;
